import { render, staticRenderFns } from "./CompleteProfileReminder.vue?vue&type=template&id=5ae6170e"
import script from "./CompleteProfileReminder.vue?vue&type=script&lang=js"
export * from "./CompleteProfileReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports